export default "__VITE_ASSET__D$y1pH1q__"